import React from "react";
import {
	Container,
	Box,
	Typography,
	Button,
	Alert,
} from "@mui/material";

import { SiteAuthHeader } from "../../components/AuthHeader";
import { SiteRouterLink } from "../../../components/RouterLink";
import { AuthPaper } from "../../components/AuthPaper";
import { useI18n } from "./locales";
import { papi } from "@haohan-frontend/papi";
import { Helmet } from "react-helmet-async";
import { AuthActiveUserDTO } from "@haohan/papi-dto";
import { useNavigate } from "react-router-dom";

export function AuthVerifyEmail() {
	const { t, Trans, lang } = useI18n();
	const [activeUser, setActiveUser] = React.useState<AuthActiveUserDTO>();
	const [ success, setSuccess ] = React.useState(false);
	const navigate = useNavigate();
	const verifyEmail = async () => {
		try {
			await papi.auth.verifyEmail();
			setSuccess(true);
		} catch {
			navigate(`/${lang}/auth/login`);
		}
	}
	const loadActiveUser = async () => {
		try {
			const user = await papi.auth.loadActiveUser();
			setActiveUser(user);
		} catch {
			navigate(`/${lang}/auth/login`);
		}
	}
	React.useEffect(() => {
		loadActiveUser();
	}, []);

	if (!activeUser) {
		return null;
	}
	return (
		<>
			<Helmet>
				<title>{t('actions.Verify your email address')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container maxWidth="xs" sx={{pb: 8, pt: 14}}>
					<AuthPaper
						rightColumn={(
							<>
								<Typography
									display='block'
									fontWeight='bold'
									mb={.5}
									textAlign='center'
									variant='h6'
								>
									{t('actions.Verify your email address')}
								</Typography>
								<Box position='relative'>
									{!success && (
										<Typography
											display='block'
											fontSize={14}
											textAlign='center'
										>
											<Trans
												i18nKey="Please confirm that you want to use <0>{{email}}</0> as your email address in Haohan.io account"
												values={{ email: activeUser.email }}
												components={[
													<Typography
														display='inline'
														fontSize="inherit"
														color="primary"
													/>
												]}
											/>.<br/>
											{t("Once it's done you will get access to your account")}.
										</Typography>
									)}

									{success && (
										<Box mt={2}>
											<Alert severity="success">
												<Trans
													i18nKey="We have sent instructions to <0>{{email}}</0>"
													components={[
														<Typography color="primary" fontSize="inherit" display="inline" />
													]}
													values={{ email: activeUser.email }}
												/>.{' '}
												{t('Follow it to verify your email address')}.
											</Alert>
										</Box>
									)}

									{!success && (
										<Box mt={4}>
											<Button
												fullWidth
												size="large"
												onClick={verifyEmail}
												variant='contained'
											>
												{t("actions.Verify Email")}
											</Button>
										</Box>

									)}
								</Box>
								<Typography
									mt={1}
									color='GrayText'
									fontSize={14}
									textAlign='center'
								>
									<Trans
										i18nKey="or <0>Sign in</0> another account"
										components={[
											<SiteRouterLink
												to="/auth/login"
												underline="hover"
												fontSize="inherit"
											/>
										]}
									/>
								</Typography>
							</>
						)}
					/>
				</Container>
			</main>
		</>
	);
}
